export default function SquadsChange(squads) {
  return { type: 'Squads_Change', payload: squads };
}
